import { PropsWithChildren } from 'react'

const ItemCount = ({ children }: PropsWithChildren<{}>) => (
  <div className="rounded-full border border-solid border-blue/30 px-2.5 py-0.5 text-xs">
    <b className="text-blue">{children}</b>
  </div>
)

export default ItemCount
